<mat-card id="badArea" class="speech-bubble" style="padding-left: 5px; padding-right: 5px" *ngIf="ipadAppear">
  <div style="text-align: center">
    <div class="notification" style="margin-top: 2%;"></div>
    <div class="titleFont"  style="padding-bottom: 10px; ">Notifications </div>

    <div style="padding-top: 5px" >
      <mat-button-toggle-group [(ngModel)]="screenMode" (click)="resetScreen()">
        <mat-button-toggle checked class="beigeButton"  value="C">Container</mat-button-toggle>
        <mat-button-toggle class="beigeButton" value="B" >Booking</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div style="padding-top: 10px" >
      <mat-form-field class="myOption2"  appearance="outline">
        <mat-label>Event Types</mat-label>
        <mat-select  [(value)]="eventChoice" >
          <mat-option  *ngFor="let lr of eventChoices" [value]="lr.code">{{lr.description}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex-item3" style="padding-top: 10px">
      <div  *ngIf="screenMode=='C'" class="lowerCaseLetters" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Container Numbers</div>
      <div  *ngIf="screenMode=='B'" class="lowerCaseLetters" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Booking Numbers</div>
      <mat-form-field *ngIf="screenMode=='C'"  appearance="outline" class="newField" >
        <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
      </mat-form-field>
      <mat-form-field *ngIf="screenMode=='B'"  appearance="outline" class="newField2" >
        <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
      </mat-form-field>
    </div>
    <div style="text-align: center">
      <div class="errorDiv2"  style="text-align: center" *ngIf="submitted && didntEnterShit && screenMode=='C'">Must Have 1 Container</div>
      <div class="errorDiv2"  style="text-align: center" *ngIf="submitted && didntEnterShit && screenMode=='B'">Must Have 1 Booking</div>
      <div class="errorDiv2" style="text-align: center" *ngIf="submitted && badChars">Invalid Character in {{containerNum}}</div>

    </div>
  </div>

  <mat-toolbar mat-toolbar class="toolbar2">
    <mat-toolbar-row style="justify-content: center">
      <button mat-raised-button (click)="getSearchItems()"   class="blueButton" >Notify Me</button>
      <span class="example-fill-remaining-space3"></span>

      <button mat-raised-button   class="redButton" (click)="wipeOutSearch()" >Clear List</button>

    </mat-toolbar-row>
  </mat-toolbar>

</mat-card>



<mat-card class="quickView" *ngIf="showQuickView" (touchstart)="showHideSearch()">
  <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
    <tr>
      <td style="width: 18%">
        <div class="maher" (click)="myApp.showCharts()"></div>
      </td>
      <td style="width: 70%">
        <div >
          <mat-form-field class="search"  appearance="outline" >
            <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
            <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/notification.png" ></mat-icon>
            <input  maxlength="30" style="padding-left: 20px;"  matInput (touchstart)="dontShowSearch()" (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
          </mat-form-field>
        </div>
      </td>
      <td style="width: 20%" *ngIf="ipadApp">
        <div >
          <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
        </div>
      </td>
    </tr>
  </table>

  <div class="flex-item2" >
    <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
      <ng-container matColumnDef="check" >
        <mat-header-cell *matHeaderCellDef  matTooltip="click to check/uncheck all" class="myHeader" style="padding-left: 5px; padding-right: 5px"><img (touchstart)="dontShowSearch()" (click)="checkAll('E')" style="vertical-align: center;height:26px; width: 26px" src="assets/check_circle_white.png" ></mat-header-cell>
        <mat-cell style="padding-left: 5px" *matCellDef="let row">
          <mat-checkbox  #mySel color="warn" (click)="$event.stopPropagation()"
                         (touchstart)="dontShowSearch()"
                        (change)="masterToggle(row,selection.isSelected(row)) ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="entity_id" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Item</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.entity_id}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="entityDisp" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Type</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.entityDisp}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="eventDisp" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Event</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.eventDisp}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="status" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Status</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.status}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="created" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Created</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.created}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="notified" >
        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Notified</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.notified}}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
      <mat-row   *matRowDef="let row; columns: qvColumns;" class="table-row" ></mat-row>
    </mat-table>
    <mat-toolbar style="width: 100%; display: unset">
      <mat-toolbar-row style="width: 100%; vertical-align: top ">
        <div style="padding-left: 3%">
          <button mat-raised-button (click)="deleteRecords()" (touchstart)="dontShowSearch()" class="blueButton" >Delete</button>
        </div>

        <mat-paginator class="myPaginator" (touchstart)="dontShowSearch()"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
</mat-card>
